import * as ViewletEditorText from './ViewletEditorText.js'

export const name = 'EditorText'

// prettier-ignore
export const Commands = {
    // TODO command to set cursor position
}

// prettier-ignore
export const LazyCommands = {
  applyEdit: () => import('../EditorCommand/EditorCommandApplyEdit.js'),
  blur: () => import('../EditorCommand/EditorCommandBlur.js'),
  braceCompletion: () => import('../EditorCommand/EditorCommandBraceCompletion.js'),
  cancelSelection: () => import('../EditorCommand/EditorCommandCancelSelection.js'),
  contextMenu: () => import('../EditorCommand/EditorCommandHandleContextMenu.js'),
  copyLineDown: () => import('../EditorCommand/EditorCommandCopyLineDown.js'),
  copyLineUp: () => import('../EditorCommand/EditorCommandCopyLineUp.js'),
  cursorLeft: () => import('../EditorCommand/EditorCommandCursorCharacterLeft.js'),
  cursorCharacterLeft: () => import('../EditorCommand/EditorCommandCursorCharacterLeft.js'),
  cursorCharacterRight: () => import('../EditorCommand/EditorCommandCursorCharacterRight.js'),
  cursorRight: () => import('../EditorCommand/EditorCommandCursorCharacterRight.js'),
  cursorDown: () => import('../EditorCommand/EditorCommandCursorDown.js'),
  cursorEnd: () => import('../EditorCommand/EditorCommandCursorEnd.js'),
  cursorHome: () => import('../EditorCommand/EditorCommandCursorHome.js'),
  cursorSet: () => import('../EditorCommand/EditorCommandCursorSet.js'),
  cursorUp: () => import('../EditorCommand/EditorCommandCursorUp.js'),
  cursorWordLeft: () => import('../EditorCommand/EditorCommandCursorWordLeft.js'),
  cursorWordPartLeft: () => import('../EditorCommand/EditorCommandCursorWordPartLeft.js'),
  cursorWordPartRight: () => import('../EditorCommand/EditorCommandCursorWordPartRight.js'),
  cursorWordRight: () => import('../EditorCommand/EditorCommandCursorWordRight.js'),
  cut: () => import('../EditorCommand/EditorCommandCut.js'),
  deleteAllLeft: () => import('../EditorCommand/EditorCommandDeleteAllLeft.js'),
  deleteAllRight: () => import('../EditorCommand/EditorCommandDeleteAllRight.js'),
  deleteLeft: () => import('../EditorCommand/EditorCommandDeleteCharacterLeft.js'),
  deleteRight: () => import('../EditorCommand/EditorCommandDeleteCharacterRight.js'),
  deleteWordLeft: () => import('../EditorCommand/EditorCommandDeleteWordLeft.js'),
  deleteWordPartLeft: () => import('../EditorCommand/EditorCommandDeleteWordPartLeft.js'),
  deleteWordPartRight: () => import('../EditorCommand/EditorCommandDeleteWordPartRight.js'),
  deleteWordRight: () => import('../EditorCommand/EditorCommandDeleteWordRight.js'),
  openCompletion: () => import('../EditorCommand/EditorCommandCompletion.js'),
  compositionStart: () => import('../EditorCommand/EditorCommandComposition.js'),
  compositionUpdate: () => import('../EditorCommand/EditorCommandComposition.js'),
  compositionEnd: () => import('../EditorCommand/EditorCommandComposition.js'),
  copy: () => import('../EditorCommand/EditorCommandCopy.js'),
  openFind: () => import('../EditorCommand/EditorCommandOpenFind.js'),
  setSelections: () => import('../EditorCommand/EditorCommandSetSelections.js'),
  format: () => import('../EditorCommand/EditorCommandFormat.js'),
  goToDefinition: () => import('../EditorCommand/EditorCommandGoToDefinition.js'),
  goToTypeDefinition: () => import('../EditorCommand/EditorCommandGoToTypeDefinition.js'),
  handleBeforeInputFromContentEditable: () => import('../EditorCommand/EditorCommandHandleNativeBeforeInputFromContentEditable.js'),
  handleDoubleClick: () => import('../EditorCommand/EditorCommandHandleDoubleClick.js'),
  handleMouseMove: () => import('../EditorCommand/EditorCommandHandleMouseMove.js'),
  handleMouseMoveWithAltKey: () => import('../EditorCommand/EditorCommandHandleMouseMoveWithAltKey.js'),
  handleNativeSelectionChange: () => import('../EditorCommand/EditorCommandHandleNativeSelectionChange.js'),
  handleScrollBarClick: () => import('../EditorCommand/EditorCommandHandleScrollBarPointerDown.js'),
  handleScrollBarPointerDown: () => import('../EditorCommand/EditorCommandHandleScrollBarPointerDown.js'),
  handleScrollBarMove: () => import('../EditorCommand/EditorCommandHandleScrollBarMove.js'),
  handleSingleClick: () => import('../EditorCommand/EditorCommandHandleSingleClick.js'),
  handleTab: () => import('../EditorCommand/EditorCommandHandleTab.js'),
  handleTouchEnd: () => import('../EditorCommand/EditorCommandHandleTouchEnd.js'),
  handleTouchMove: () => import('../EditorCommand/EditorCommandHandleTouchMove.js'),
  handleTouchStart: () => import('../EditorCommand/EditorCommandHandleTouchStart.js'),
  handleTripleClick: () => import('../EditorCommand/EditorCommandHandleTripleClick.js'),
  indentLess: () => import('../EditorCommand/EditorCommandIndentLess.js'),
  indentMore: () => import('../EditorCommand/EditorCommandIndentMore.js'),
  insertLineBreak: () => import('../EditorCommand/EditorCommandInsertLineBreak.js'),
  moveLineDown: () => import('../EditorCommand/EditorCommandMoveLineDown.js'),
  moveLineUp: () => import('../EditorCommand/EditorCommandMoveLineUp.js'),
  moveRectangleSelection: () => import('../EditorCommand/EditorCommandMoveRectangleSelection.js'),
  moveRectangleSelectionPx: () => import('../EditorCommand/EditorCommandMoveRectangleSelectionPx.js'),
  moveSelection: () => import('../EditorCommand/EditorCommandMoveSelection.js'),
  moveSelectionPx: () => import('../EditorCommand/EditorCommandMoveSelectionPx.js'),
  paste: () => import('../EditorCommand/EditorCommandPaste.js'),
  pasteText: () => import('../EditorCommand/EditorCommandPasteText.js'),
  save: () => import('../EditorCommand/EditorCommandSave.js'),
  selectAll: () => import('../EditorCommand/EditorCommandSelectAll.js'),
  selectAllOccurrences: () => import('../EditorCommand/EditorCommandSelectAllOccurrences.js'),
  selectCharacterLeft: () => import('../EditorCommand/EditorCommandSelectCharacterLeft.js'),
  selectCharacterRight: () => import('../EditorCommand/EditorCommandSelectCharacterRight.js'),
  selectDown: () => import('../EditorCommand/EditorCommandSelectDown.js'),
  selectInsideString: () => import('../EditorCommand/EditorCommandSelectInsideString.js'),
  selectLine: () => import('../EditorCommand/EditorCommandSelectLine.js'),
  selectNextOccurrence: () => import('../EditorCommand/EditorCommandSelectNextOccurrence.js'),
  selectUp: () => import('../EditorCommand/EditorCommandSelectUp.js'),
  selectWord: () => import('../EditorCommand/EditorCommandSelectWord.js'),
  selectWordLeft: () => import('../EditorCommand/EditorCommandSelectWordLeft.js'),
  selectWordRight: () => import('../EditorCommand/EditorCommandSelectWordRight.js'),
  setDecorations: () => import('../EditorCommand/EditorCommandSetDecorations.js'),
  setDeltaY: () => import('../EditorCommand/EditorCommandSetDeltaY.js'),
  setLanguageId: () => import('../EditorCommand/EditorCommandSetLanguageId.js'),
  sortLinesAscending: () => import('../EditorCommand/EditorCommandSortLinesAscending.js'),
  tabCompletion: () => import('../EditorCommand/EditorCommandTabCompletion.js'),
  toggleBlockComment: () => import('../EditorCommand/EditorCommandToggleBlockComment.js'),
  toggleComment: () => import('../EditorCommand/EditorCommandToggleComment.js'),
  type: () => import('../EditorCommand/EditorCommandType.js'),
  undo: () => import('../EditorCommand/EditorCommandUndo.js'),
  unIndent: () => import('../EditorCommand/EditorCommandUnindent.js'),
}

// prettier-ignore
export const Events = {
  'languages.changed': ViewletEditorText.handleLanguagesChanged,
  // 'editor.change': ViewletEditorText.handleEditorChange,
  // 'tokenizer.changed': ViewletEditorText.handleTokenizeChange,
}

export const Css = ['/css/parts/ViewletEditor.css', '/css/parts/ScrollBar.css']

export * from './ViewletEditorText.js'
